/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { workspacesDelete } from "../../funcs/workspacesDelete.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations.DeleteApiWorkspaceServiceV1WorkspacesIdRequest$inboundSchema,
};

export const tool$workspacesDelete: ToolDefinition<typeof args> = {
  name: "workspaces_delete",
  description: `Delete workspace`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await workspacesDelete(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
